import { c as _c } from "react/compiler-runtime";
import './child-bio-details.scss';
import { useTranslation } from 'react-i18next';
import type { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { countryToIso } from '@sola/schema/dotcom/shared/geo.ts';
import { getNote } from '../../organisms-cms/child-bio/utils/childNote.tsx';
import { getAge } from '../../utils/child-bio.ts';

/**
 * Child bio info section
 */
export const ChildBioInfo = t0 => {
  const $ = _c(66);
  const {
    details
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["bio"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const {
    ageInYearsAndMonths,
    country,
    localId
  } = details;
  let t2;
  if ($[1] !== ageInYearsAndMonths) {
    t2 = getAge(ageInYearsAndMonths);
    $[1] = ageInYearsAndMonths;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const age = t2;
  let t3;
  if ($[3] !== details) {
    t3 = getNote(details);
    $[3] = details;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const note = t3;
  let t4;
  if ($[5] !== country || $[6] !== localId) {
    t4 = countryToIso(country, localId);
    $[5] = country;
    $[6] = localId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const countryIso = t4;
  const countryKey = `geo:countries.${countryIso}.nameS`;
  let t5;
  if ($[8] !== t) {
    t5 = t("bio:age");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <span className="label-xl label-potent ChildBioDetails__label">{t5}</span>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== age || $[13] !== t6) {
    t7 = <p>{t6}{age}</p>;
    $[12] = age;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("bio:birthday");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <span className="label-xl label-potent ChildBioDetails__label">{t8}</span>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== details.birthDate || $[20] !== t) {
    t10 = new Date(details.birthDate || "").toLocaleDateString(t("bio:localeFormat"), {
      year: "numeric",
      month: "long",
      day: "numeric"
    });
    $[19] = details.birthDate;
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== details.isBirthDateEstimated || $[23] !== t) {
    t11 = details.isBirthDateEstimated && t("bio:estimatedBirthday");
    $[22] = details.isBirthDateEstimated;
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t9) {
    t12 = <p>{t9}{t10}{t11}</p>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t("bio:gender");
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t13) {
    t14 = <span className="label-xl label-potent ChildBioDetails__label">{t13}</span>;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== details.gender || $[34] !== t) {
    t15 = t("bio:genders", {
      context: details.gender.toString()
    });
    $[33] = details.gender;
    $[34] = t;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t14 || $[37] !== t15) {
    t16 = <p>{t14}{t15}</p>;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t) {
    t17 = t("bio:location");
    $[39] = t;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t17) {
    t18 = <span className="label-xl label-potent ChildBioDetails__label">{t17}</span>;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  const t19 = countryKey as unknown as TemplateStringsArray;
  let t20;
  if ($[43] !== t || $[44] !== t19) {
    t20 = t(t19);
    $[43] = t;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t18 || $[47] !== t20) {
    t21 = <p>{t18}{t20}</p>;
    $[46] = t18;
    $[47] = t20;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  let t22;
  if ($[49] !== t) {
    t22 = t("bio:localId");
    $[49] = t;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t22) {
    t23 = <span className="label-xl label-potent ChildBioDetails__label">{t22}</span>;
    $[51] = t22;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== details.localId || $[54] !== t23) {
    t24 = <p>{t23}{details.localId}</p>;
    $[53] = details.localId;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== note || $[57] !== t) {
    t25 = note && <p><span className="label-xl label-potent ChildBioDetails__label">{t("bio:note", {
          interpolation: {
            escapeValue: false
          }
        })}</span>{note}</p>;
    $[56] = note;
    $[57] = t;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t12 || $[60] !== t16 || $[61] !== t21 || $[62] !== t24 || $[63] !== t25 || $[64] !== t7) {
    t26 = <div>{t7}{t12}{t16}{t21}{t24}{t25}</div>;
    $[59] = t12;
    $[60] = t16;
    $[61] = t21;
    $[62] = t24;
    $[63] = t25;
    $[64] = t7;
    $[65] = t26;
  } else {
    t26 = $[65];
  }
  return t26;
};